<template>
  <div class="ui simple dropdown item borderless ciindicator">
    <a class="ui yellow label" @click="show_detail">
      兼容性问题
    </a>
  </div>
</template>

<script>
export default {
  name: 'CompatibilityIndicator',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
    show_detail() {
      var browser = this.browser();
      this.show_error(`您的浏览器${browser.name}(${browser.version})可能存在兼容性问题。为了最好的体验，请使用谷歌浏览器，火狐浏览器，Safari或者Edge来访问红豆云。`);
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
div.ciindicator {
  padding-left: 0 !important;
}
</style>

